export const paths = {
  home: '/home',
  report: '/report',
  logout: '/logout',
  root: '/',
};
